module.exports = __webpack_public_path__ + "img/cam10_noc-slup.979f2d89.jpg";